<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="showAdd"
        :show-del="showDel"
        @on-add="showFormModalDialog"
      />
      <RoleDialog
        :id="entityId"
        :visible="modalForm"
        :width="400"
        :action="url"
        @on-close="onModalClose"
      />
      <RolePermissionDialog
        :id="entityId"
        :width="600"
        :visible="modalPermission"
        :caption="permissionCaption"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import RoleDialog from './dialog/role-dialog'
import RolePermissionDialog from './dialog/role-permission'
import request from '@/utils/request'
export default {
  name: 'Role',
  components: {
    TableWrapper,
    RoleDialog,
    RolePermissionDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/role',
      modalForm: false,
      entityId: 0,
      modCount: 0,
      showAdd: true,
      showDel: true,
      modalPermission: false,
      currentRole: ''
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    permissionCaption() {
      return '角色权限配置: ' + this.currentRole
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '角色名称', placeholder: '请输入角色名称...', name: 'name', width: 'auto', type: 'input' },
          { label: '角色代号', placeholder: '请输入角色代号...', name: 'code', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      const that = this
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '角色名称', align: 'left', key: 'name', sortable: true, ellipsis: true, tooltip: true },
        { title: '角色代号', align: 'left', key: 'code', sortable: true, ellipsis: true, tooltip: true },
        { title: '创建时间', align: 'center', sortable: true, width: 160, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'visible', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { }
            }, params.row.visible === 1 ? '可见' : '隐藏')
          }
        },
        { title: '操作', align: 'center', width: 185,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showPermissionModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-cogs': true, 'cell-icon-link': true }}),
                h('span', {}, '配置')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              that.showDel ? h('a', {
                style: { color: '#126D91' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ]) : h()
            ])
          }
        }
      ]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showPermissionModalDialog: function(id, name) {
      this.entityId = id ? parseInt(id) : 0
      this.currentRole = name
      this.modalPermission = true
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除角色信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '角色 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '角色 `' + name + '` 删除失败, 错误信息: ' + error
            })
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      this.modalPermission = false
      this.currentRole = ''
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>

